import React from 'react';
import './DateFormatModal.css';

function DateFormatModal({
  isOpen,
  onClose,
  dateFormat,
  onFormatChange,
  selectedDate,
}) {
  if (!isOpen) return null;

  // Import the formatter
  const { formatGameDate } = require('../../utils/dateFormatter');

  // Use actual selected date or fallback example
  const exampleDate = selectedDate || '2026-01-22';

  const formatOptions = [
    {
      value: 'full',
      label: formatGameDate(exampleDate, 'full'),
      description: 'Full date with weekday and year',
    },
    {
      value: 'no-weekday',
      label: formatGameDate(exampleDate, 'no-weekday'),
      description: 'No weekday',
    },
    {
      value: 'no-year',
      label: formatGameDate(exampleDate, 'no-year'),
      description: 'No year',
    },
    {
      value: 'month-day',
      label: formatGameDate(exampleDate, 'month-day'),
      description: 'Month and day only',
    },
    {
      value: 'short',
      label: formatGameDate(exampleDate, 'short'),
      description: 'Abbreviated month with year',
    },
    {
      value: 'short-no-year',
      label: formatGameDate(exampleDate, 'short-no-year'),
      description: 'Abbreviated month, no year',
    },
    {
      value: 'numeric',
      label: formatGameDate(exampleDate, 'numeric'),
      description: 'Numeric short format',
    },
    {
      value: 'numeric-full',
      label: formatGameDate(exampleDate, 'numeric-full'),
      description: 'Numeric full format',
    },
  ];

  return (
    <div className="date-format-overlay" onClick={onClose}>
      <div className="date-format-modal" onClick={(e) => e.stopPropagation()}>
        <div className="date-format-header">
          <h2>Date Format Options</h2>
          <button className="date-format-close" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="date-format-content">
          <p className="format-description">
            Choose how you want dates to appear on your graphics
          </p>

          <div className="format-options">
            {formatOptions.map((option) => (
              <label
                key={option.value}
                className={`format-option ${dateFormat === option.value ? 'selected' : ''}`}
              >
                <input
                  type="radio"
                  name="dateFormat"
                  value={option.value}
                  checked={dateFormat === option.value}
                  onChange={(e) => onFormatChange(e.target.value)}
                />
                <div className="format-label-content">
                  <div className="format-example">{option.label}</div>
                  <div className="format-desc">{option.description}</div>
                </div>
              </label>
            ))}
          </div>
        </div>

        <div className="date-format-footer">
          <button className="btn-primary" onClick={onClose}>
            Done
          </button>
        </div>
      </div>
    </div>
  );
}

export default DateFormatModal;
